<div class="container">
  <div *ngIf="fatherChallenge?.acceptanceDate || (challengeDetailList && challengeDetailList.length > 0)">

    <table #distributionTable data-testid="distributionTable" class="detail-tab distributionTable">
      <ng-container *ngIf="fatherChallenge?.acceptanceDate">
        <thead>

          <tr>
            <th id="acceptationChallenge" class="pl-4" style="text-align: center;">{{ 'challenge.acceptationChallenge' |
              translate }}</th>
            <th id="acceptation" class="pl-4" style="text-align: center;">{{ 'challenge.acceptation' | translate }}</th>
          </tr>
        </thead>

        <!-- Una riga sola: l'adesione e' una per coppia sfida/cliente. La data sta
             sulla sfida, non sul livello, dove la query la ripete su ognuno. -->
        <tbody>
          <tr>
            <td style="text-align: center;" [ngClass]="checkExpiredChallengeDetail()">{{ fatherChallenge.description }}
            </td>
            <td style="text-align: center;" [ngClass]="checkExpiredChallengeDetail()">{{
              fatherChallenge.acceptanceDate }}</td>
          </tr>
        </tbody>
      </ng-container>

      <ng-container *ngIf="challengeDetailList && challengeDetailList.length > 0">
        <thead>
          <tr>
            <th id="levelName" class="pl-4" style="text-align: center;">{{ 'challenge.levelName' | translate }}</th>
            <th id="achievementDate" class="pl-4" style="text-align: center;">{{ 'challenge.achievement_date' | translate
              }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let challengeDetail of challengeDetailList; let i = index;">
            <td style="text-align: center;" [ngClass]="checkExpiredChallengeDetail()">{{ challengeDetail.description }}
            </td>
            <td style="text-align: center;" [ngClass]="checkExpiredChallengeDetail()">{{
              challengeDetail.levelAchievementDate }}</td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <p *ngIf="!challengeDetailList || challengeDetailList.length === 0" style="text-align: center;">
    {{ 'challenge.no_reached_levels' | translate}}
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/challenge/challengeinfo-details/challengeinfo-details.component.html